import React, { Fragment, useState } from 'react';
import styles from '../../styles.module.scss';
import { formatDate } from '../../utils/helper';
import PropTypes from 'prop-types';

const VendorProgramItem = props => {
  const {
    vendorProgram,
    onDeleteVendorProgram,
    deleteLoading = false,
    isGroup,
    index,
    hasBillingAccess,
    onHandleEditButton
  } = props;

  const handleDeleteVendorProgram = () => {
    onDeleteVendorProgram(vendorProgram);
  };

  const handleEditButton = () => {
    onHandleEditButton(vendorProgram)
  }

  const renderHiddenField = (className, key, value) => {
    const name = `${isGroup ? 'group' : 'organization'}[vendor_point_solutions][${index}][${key}]`;

    return <input
      value={value}
      className={className}
      type='hidden'
      name={name}
    />;
  };

  return (
    <tr className={vendorProgram.isExcluded ? styles.hide : {}}>
      <td className={styles.tableColVendorPoint}>
        <span>{vendorProgram.vendorName}</span>
        {renderHiddenField('vendor-id', 'vendor_id', vendorProgram.vendorId)}
        {renderHiddenField('exclusion-flag', 'exclusion_flg', vendorProgram.isExcluded ? 'Y' : 'N')}
        {renderHiddenField('organization-id', 'organization_id', vendorProgram.organizationId)}
        {renderHiddenField('vendor-program-id', 'vendor_program_id', vendorProgram.vendorProgramId || '')}
      </td>
      <td className={styles.tableColCategory}>
        <span>{vendorProgram.categoryName}</span>
        {renderHiddenField('category', 'category', vendorProgram.categoryCode)}
      </td>
      <td className={styles.tableColDate}>
        {formatDate(vendorProgram.effectiveStartDate)}
        {renderHiddenField('effective-start-date', 'effective_start_date', formatDate(vendorProgram.effectiveStartDate))}
      </td>
      <td className={styles.tableColPhoneNumber}>
        {vendorProgram.contact}
        {renderHiddenField('contact', 'contact', vendorProgram.contact)}
      </td>
      <td className={styles.tableColWebsite}>
        <a href={vendorProgram.website} target='_blank'>{vendorProgram.website}</a>
        {renderHiddenField('website', 'website', vendorProgram.website)}
      </td>
      <td className={styles.tableColDescription}>
        {vendorProgram.description}
        {renderHiddenField('description', 'description', vendorProgram.description)}
      </td>
      {isGroup &&
        <td className={styles.tableColOwner}>
          {vendorProgram.isInherited && (
            <span className={styles.inheritedFrom}>{vendorProgram.organizationName}</span>
          )}
        </td>
      }
      {hasBillingAccess &&
        <td className={styles.tableColAction}>
          <Fragment>
            {!vendorProgram.isInherited && <a className='edit-vendor-program' onClick={handleEditButton}>Edit</a>}
            <a className='delete-vendor-program' onClick={handleDeleteVendorProgram}>{deleteLoading ? 'Deleting...' : 'Delete'}</a>
          </Fragment>
        </td>
      }
    </tr>
  );
};

VendorProgramItem.propTypes = {
  vendorProgram: PropTypes.object.isRequired,
  isGroup: PropTypes.bool.isRequired,
  onDeleteVendorProgram: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  deleteLoading: PropTypes.bool,
  hasBillingAccess: PropTypes.bool,
  onHandleEditButton: PropTypes.func.isRequired
};

export default VendorProgramItem;
